import { Component } from 'preact'
import { t } from '../../libs/translationsUtils/translations'
import Phrase from '../../libs/translationsUtils/phrase'

import {
  connectSearchBox
} from 'react-instantsearch/connectors'

export class SearchBox extends Component {
  constructor () {
    super()
    this.state = {
      enableLoader: false
    }
    this.doSearch = this.doSearch.bind(this)
    this.timeout = null
  }

  doSearch (value) {
    clearTimeout(this.timeout)
    this.props.refine(value)
    this.setState({ enableLoader: false })
    if (value === '') {
      this.props.hideSuggestionsCallback(true)
      return
    }

    this.setState({ enableLoader: true })
    this.timeout = window.setTimeout(() => {
      this.props.hideSuggestionsCallback(false)
      this.setState({ enableLoader: false })
    }, 500)
  }

  render (props, state) {
    return (
      <div className='form__row'>
        <div className='first'>
          <label htmlFor='topic_title'>
            <Phrase p='Title' />
          </label>
        </div>
        <div className='second loading-wrapper'>
          <input
            type='search'
            id='topic_title'
            placeholder={t('Forum', 'Enter a clear title here')}
            required='required'
            name='topic[title]'
            autoComplete='off'
            autoCorrect='off'
            autoCapitalize='off'
            onKeyUp={event => { this.doSearch(event.currentTarget.value) }}
          />
          {
            state.enableLoader ? (
              <span
                className='topic-suggestion-loader small-loader is-hidden'>
                <img
                  src={`${props.defaultCdn}/images/spinner.gif`}
                  alt='loading...' />
              </span>
            ) : null
          }
        </div>
      </div>
    )
  }
}

const CustomSearchBox = connectSearchBox(SearchBox)

export default CustomSearchBox
